/* eslint-disable */
/* tslint:disable */

import { useEffect, useState } from 'react'
import middleBanner from '../../images/middle.png'

import TimeLine from '../../components/timeline/timeline'
import arrowRight from '../../images/arrow-right.svg'
import MatchInfo from './matchInfo'

import { getEnv } from '../../helpers/mobx-easy-wrapper'
import { NoticeItem } from '../activity/notice/notice'
import MatchEnter from './enter'
import PrizeInfo from './prize'
import TrendNews from './trendNews'

const Home = () => {
  const month = new Date().getMonth() + 1

  const [category, setCategory] = useState('公告')
  const [data, setData] = useState<Array<NoticeItem>>()

  useEffect(() => {
    const { apiFactory } = getEnv()
    async function fetchData() {
      const response = await apiFactory.activityService.getNoticeData(1, '')
      setData(response.items)
    }
    fetchData()
  }, [])

  return (
    <div className="home">
      {/*  <Banner />*/}
      <MatchInfo />

      {/* <div
        className="home-full-row bg_fill"
        style={{ backgroundImage: `url(${middleBanner})` }}>
        <div className="middleBanner-cover">
          <div className="middleBanner-desc">
            “十四五”规划和2035年远景目标纲要提出，更好保护和激励高价值专利，并首次将“每万人口高价值发明专利拥有量”纳入经济社会发展主要指标。国务院办公厅印发的《专利转化运用专项行动方案（2023
            -2025年）》对于我国大力推动专利产业化，加快创新成果向现实生产力转化作出专项部署，提出到2025年，推动一批高价值专利实现产业化。2024年上海市人民政府办公厅印发《上海市专利转化运用专项行动实施方案》，立足上海实际，以充分发挥知识产权制度供给和技术供给双重作用、有效利用专利的权益纽带和信息链接功能为关键落点，大力推动专利产业化，加快创新成果向现实生产力转化。
          </div>
        </div>
      </div> */}

      <div
        className="jury__line outlineTitle"
        style={{
          textAlign: 'center',
          marginBottom: '60px',
          marginTop: '65px',
        }}>
        <label className={`enter_label  active `}>大赛赛程</label>
      </div>

      <div className="home-row schedule_time">
        <TimeLine />
      </div>
      <div className="home-row" style={{ marginBottom: '64px' }}>
        <div
          onClick={() => {
            window.location.href = '/schedule'
          }}
          className="link-detail container-linkDetail">
          <img src={arrowRight} />
          查看大赛赛程详情
        </div>
      </div>
      {/* <MatchEnter /> */}

      <PrizeInfo />

      {/* <div className='jury__line outlineTitle' style={{ textAlign: 'center', paddingTop: '0' }}>
        <label className={`enter_label  active `}>专家团队</label>
      </div>

      <JuryWidget /> */}

      {/* 大赛动态，暂时隐藏 */}
      {/* <TrendNews /> */}

      <div
        className="jury__line outlineTitle"
        style={{ textAlign: 'center', marginTop: '128px' }}>
        <label className={`enter_label  active `}>组织机构</label>
      </div>
      <div
        className="home-row org-container row-padding"
        style={{ marginTop: '62px' }}>
        <div className="org-subTitle">指导单位</div>
        <div className="org-subUnit">
          <div className="unitName">
            <a href="https://sipa.sh.gov.cn/" target={'_blank'}>
              上海市知识产权局
            </a>
          </div>
          <div className="unitName">
            <a href="https://stcsm.sh.gov.cn/" target={'_blank'}>
              上海市科学技术委员会
            </a>
          </div>
          <div className="unitName">
            <a href="http://edu.sh.gov.cn/" target={'_blank'}>
              上海市教育委员会
            </a>
          </div>
        </div>
      </div>
      <div
        className="home-row org-container row-padding"
        style={{ marginTop: '30px', marginBottom: '128px' }}>
        <div className="org-subTitle">主办单位</div>
        <div className="org-subUnit">
          <div className="unitName">
            <a href="http://www.stte.com/" target={'_blank'}>
              上海技术交易所
            </a>
          </div>
          <div className="unitName">
            <a href="http://stdc.shec.edu.cn/" target={'_blank'}>
              上海市高校科技发展中心
            </a>
          </div>
          <div className="unitName">
            <a href="http://www.ssip.com.cn/" target={'_blank'}>
              上海市知识产权服务中心
            </a>
          </div>
        </div>
      </div>

      {/* <div
        className="home-row org-container row-padding"
        style={{ marginTop: '30px' }}>
        <div className="org-subTitle">协办单位</div>
        <div className="org-subUnit">
          <div className="unitName">各区知识产权局</div>
        </div>
      </div> */}

      {/* <div
        className="home-row org-container row-padding"
        style={{ marginTop: '30px' }}>
        <div className="org-subTitle">支持平台</div>
        <div className="org-subUnit">
          <div className="unitName">长三角科技要素交易中心</div>
          <div className="unitName">长三角科技成果路演中心</div>
        </div>
      </div>

      <div
        className="home-row org-container row-padding"
        style={{ marginTop: '32px', marginBottom: '128px' }}>
        <div className="org-subTitle">支持单位</div>
        <div className="org-subUnit">
          <div className="unitName">
            长三角国创中心有机功能材料与应用技术研究所
          </div>
          <div className="unitName">大零号湾·国盛健康云城</div>
          <div className="unitName">科创板日报</div>
          <div className="unitName">瑞谷传祺</div>
          <div className="unitName">上海集成电路设计孵化基地</div>
          <div className="unitName">上海交通大学国家大学科技园</div>
          <div className="unitName">上海市嘉定区科技创新服务联合会</div>
          <div className="unitName">上海市静安区宝山路街道办事处</div>
          <div className="unitName">上海退役军人创新创业示范园</div>
          <div className="unitName">上海新能源行业协会</div>
          <div className="unitName">上海徐汇百羿医学创新转化中心</div>
          <div className="unitName">上海紫竹高新区科学技术协会</div>
          <div className="unitName">S创</div>
          <div className="unitName">同济大学国家大学科技园核心园</div>
          <div className="unitName">湾谷科技园</div>
          <div className="unitName">新业坊Lab·源创孵化器</div>
          <div className="unitName">新业坊Lab·中科技物联创中心</div>
          <div className="unitName">新谷国际</div>
          <div className="unitName">医工学人科技推广院</div>
          <div className="unitName">医睿星资本</div>
          <div className="unitName tip">(排名不分先后，按拼音首字母排序)</div>
        </div>
      </div> */}

      {/* <div className='home-row org-container row-padding' style={{ marginTop: '30px' }}>
        <div className='org-subTitle'>赛事服务战略合作</div>
        <div className='org-subUnit' style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
          <div className='unitName'>同济大学国家大学科技园核心园</div>
        </div>
      </div> */}
      {/* <div className='home-row org-container row-padding' style={{ marginTop: '30px' }}>
                <div className='org-subTitle'>合作单位</div>
                <div className='org-subUnit'>
                    <div className='unitName'>
                        <a href='http://www.shtic.com/' target={'_blank'}>
                            上海知识产权交易中心（拟）
                        </a>
                    </div>
                </div>
            </div> */}
      {/* <div className='home-row org-container row-padding' style={{ marginTop: '30px' }}>
        <div className='org-subTitle'>协办单位</div>
        <div className='org-subUnit'>
          <div className='unitName'>浦东知识产权局</div>
          <div className='unitName'>黄浦知识产权局</div>
          <div className='unitName'>静安知识产权局</div>
          <div className='unitName'>徐汇知识产权局</div>
          <div className='unitName'>长宁知识产权局</div>
          <div className='unitName'>普陀知识产权局</div>
          <div className='unitName'>虹口知识产权局</div>
          <div className='unitName'>杨浦知识产权局</div>
          <div className='unitName'>宝山知识产权局</div>
          <div className='unitName'>闵行知识产权局</div>
          <div className='unitName'>嘉定知识产权局</div>
          <div className='unitName'>金山知识产权局</div>
          <div className='unitName'>松江知识产权局</div>
          <div className='unitName'>青浦知识产权局</div>
          <div className='unitName'>奉贤知识产权局</div>
          <div className='unitName'>崇明知识产权局</div>
          <div className='unitName'>临港新片区市场监管局</div>
          <div className='unitName tip'>(排名不分先后)</div>
        </div>
      </div> */}
      {/* <div className='home-row org-container row-padding' style={{ marginTop: '30px' }}>
        <div className='org-subTitle'>合作知产运营服务集聚区</div>
        <div className='org-subUnit'>
          <div className='unitName'>同济科技园</div>
          <div className='unitName'>西虹桥商务区</div>
          <div className='unitName'>上海金山工业区</div>
          <div className='unitName'>上海长江软件园</div>
          <div className='unitName'>东方美谷核心区</div>
          <div className='unitName'>上海天地软件园</div>
          <div className='unitName'>国际创新协同区</div>
          <div className='unitName'>上海蓝天经济城</div>
          <div className='unitName'>上海国际医学园区</div>
          <div className='unitName'>上海临港松江科技城</div>
          <div className='unitName'>上海虹桥临空经济示范区</div>
          <div className='unitName'>同济虹口绿色科技产业园</div>
          <div className='unitName'>黄浦区科技创业孵化基地</div>
          <div className='unitName'>上海漕河泾新兴技术开发区</div>
          <div className='unitName'>上海长兴海洋装备产业园区</div>
          <div className='unitName'>上海紫竹高新技术产业开发区</div>
          <div className='unitName'>上海市北高新技术服务业园区</div>
          <div className='unitName'>国家技术转移东部中心</div>
          <div className='unitName'>上海全国高校技术市场</div>
          <div className='unitName tip'>(排名不分先后)</div>
        </div>
      </div> */}
      {/* <div className='home-row org-container row-padding' style={{ marginTop: '32px', marginBottom: '128px' }}>
        <div className='org-subTitle'>合作单位</div>
        <div className='org-subUnit'>
          <div className='unitName'>佰傲谷BioValley</div>
          <div className='unitName'>S创</div>
          <div className='unitName'>创合汇</div>
          <div className='unitName'>长江创服</div>
          <div className='unitName'>新谷国际</div>
          <div className='unitName'>湾谷科技园</div>
          <div className='unitName'>运河湾知识产权园</div>
          <div className='unitName'>上海市相关专利超市</div>
          <div className='unitName'>复旦大学国家科技园</div>
          <div className='unitName'>腾讯众创空间（上海）</div>
          <div className='unitName'>上海市协力律师事务所</div>
          <div className='unitName'>杨浦区科技金融联合会</div>
          <div className='unitName'>同济大学国家科技园天骄湾</div>
          <div className='unitName'>上海紫竹创业投资有限公司</div>
          <div className='unitName'>上海知链众象知识产权咨询有限公司</div>
          <div className='unitName'>定海路街道（运河湾知识产权园）大学生创业基地</div>
          <div className='unitName'>长三角国家技术创新中心有机功能材料与应用技术研究所</div>
          <div className='unitName'></div>
          <div className='unitName tip'>(排名不分先后)</div>
        </div>
      </div> */}
      {/* <div
        className="home-row org-container"
        style={{ marginTop: '62px', marginBottom: '128px' }}
      >
        <div className="org-subTitle">合作媒体</div>
        <div className="org-subUnit">
          <div className="home-v2-unitLogo">
            <img src={unit1} />
          </div>
          <div className="home-v2-unitLogo">
            <img src={unit1} />
          </div>
          <div className="home-v2-unitLogo">
            <img src={unit1} />
          </div>
          <div className="home-v2-unitLogo">
            <img src={unit1} />

          </div>
        </div>
      </div> */}

      {/* <Info />
      <Service />
      <img className="home-div-activityContainer" src={banner} />*/}
    </div>
  )
}

export default Home
